<template>
  <v-dialog
    v-model="dialogBuenSeguimiento.estatus"
    max-width="1800"
    persistent
  >
    <v-card class="shadowCard">
		  <v-card-title primary-title>
        <v-img src="@/assets/iconos/secretaria.png" max-width="30" class="mr-2"></v-img>
		    <span>
		    	Reporte de <b class="blue--text">BUEN</b> seguimiento!
		    </span>
		    <v-spacer></v-spacer>

		    <v-btn
          color="#FFF800"
          class="mr-2 text-caption"
          @click="dialogReporteVendedora.estatus = true"
          small
          tile
        >
          <v-img src="@/assets/iconos/secretaria.png" max-width="25" class="mr-2"></v-img>
          Reporte Vendedora
        </v-btn>

        <v-btn
          color="primary mr-8"
          dark
          class="text-capitalize"
          @click="initialize()"
          small
          tile
        >
          <v-icon small left >mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        
		  </v-card-title>

		  <v-card-text class="mt-6">
		  	<v-row>

		  		<v-col cols="12" sm="6" md="4" lg="3">
		  			<label>Selecciona la fecha de inicio</label>
		  			<v-text-field
		  			  name="name"
		  			  label="Buscar"
		  			  id="id"
		  			  filled
		  			  dense
		  			  single-line
		  			  hide-details
		  			  v-model="fechaini"
		  			  type="date"
		  			>
		  			</v-text-field>
		  		</v-col>

		  		<v-col cols="12" sm="6" md="4" lg="3">
		  			<label>Selecciona la fecha final</label>
		  			<v-text-field
		  			  name="name"
		  			  label="Buscar"
		  			  id="id"
		  			  filled
		  			  dense
		  			  single-line
		  			  hide-details
		  			  v-model="fechafin"
		  			  type="date"
		  			>
		  			</v-text-field>
		  		</v-col>

		  		<v-col cols="12" sm="6" md="4" lg="3">
		  			<label>Selecciona una vendedora</label>
		  			<v-autocomplete
		          filled 
		          dense
		          clearable
		          v-model="vendedora"
		          :items="vendedoras"
		          item-text="nombre"
		          item-value="id_vendedora"
				  	  single-line
				  	  hide-details
		        >
		        </v-autocomplete>
		  		</v-col>

		  		<!-- <v-col cols="12" sm="6" md="4" lg="3">
		  			<label>Selecciona un estatus</label>
		  			<v-autocomplete
		          filled 
		          dense
		          clearable
		          v-model="opEstatus"
		          :items="estatus_list"
		          item-text="estatus"
		          item-value="id"
				  	  single-line
		        >
		        </v-autocomplete>
		  		</v-col> -->

		  	</v-row>

		  	<v-row>
		  		<v-col cols="12" lg="4">
		  			<label>Selecciona una opción para filtrar los twilios</label>
		  			<v-radio-group
				      v-model="opTwilio"
				      row
				      hide-details
				    >
				      <v-radio
				        label="Twilio"
				        :value="1"
				      ></v-radio>
				      <v-radio
				        label="Vendedora"
				        :value="2"
				      ></v-radio>
				      <v-radio
				        label="Todos"
				        :value="3"
				      ></v-radio>
				    </v-radio-group>
		  		</v-col>

		  		<v-col cols="12" lg="2">
		  			<label>Sin CRM</label>
		  			<v-checkbox
              v-model="sinCRM"
              label="Sin CRM"
              color="blue"
              hide-details
            ></v-checkbox>
		  		</v-col>

		  		<v-col cols="12" lg="2">
		  			<label>Sin Finalizar</label>
		  			<v-checkbox
              v-model="sinFinalizar"
              label="Sin finalizar"
              color="blue"
              hide-details
            ></v-checkbox>
		  		</v-col>

		  		<v-col cols="12" lg="2">
		  			<label>Da clic para no mostrar los SPAM</label>
		  			<v-checkbox
              v-model="sinSpam"
              label="Sin SPAM"
              color="black"
              hide-details
            ></v-checkbox>
		  		</v-col>

		  		<v-col cols="12" lg="2">
		  			<label>Ventana cerrada</label>
		  			<v-checkbox
              v-model="ventanaCerrada"
              label="Sin Ventana Cerrada"
              color="red"
              hide-details
            ></v-checkbox>
		  		</v-col>


		  	</v-row>

		  	<v-row class="mb-4">
		  		<v-col cols="12" lg="2">
		  			<v-checkbox
              v-model="msnDuplicado"
              label="Msn duplicado"
              color="red"
              hide-details
            ></v-checkbox>
          </v-col>
		  		<v-col cols="12" lg="2">
            <v-checkbox
              v-model="pdfInicio"
              label="Pdf en los 1eros Msn"
              color="blue"
              hide-details
            ></v-checkbox>
          </v-col>
		  		<v-col cols="12" lg="2">
            <v-checkbox
              v-model="clienteEspera"
              label="Cliente espera"
              color="orange"
              hide-details
            ></v-checkbox>
          </v-col>
		  		<v-col cols="12" lg="2">
            <v-checkbox
              v-model="sinError"
              label="Sin error"
              color="green"
              hide-details
            ></v-checkbox>
          </v-col>
		  		<v-col cols="12" lg="2">
            <v-checkbox
              v-model="noIniciado"
              label="No se ha mandado 1er mensaje"
              color="yellow"
              hide-details
            ></v-checkbox>
		  		</v-col>
		  	</v-row>

		    <v-row>
		    	<v-col cols="12">
		    		<!-- <div ref="chartdiv" style="width: 100%; height: 600px;" v-show="verGraficaInbi"></div> -->
		    		<v-card class="elevation-0">
		    			<v-card-title primary-title class="text-body-1">
		    			  Reporte Inbi
		    			  <v-spacer></v-spacer>
		    			  <v-btn 
				          class="mr-2" 
				          small dark color="green"
				          @click="exportExcel( tablaInbi  , 'REPORTE_INBI')"
				          tile
				        >
				          <v-icon small>mdi-microsoft-excel</v-icon>
				        </v-btn>
		    				<v-btn dark @click="dialogAlerta = true" small color="primary" v-if="selectedInbi.length > 0">REASIGNARRR</v-btn>
		    			</v-card-title>
		    			<v-card-text>
			    		  <v-data-table
				          :headers="headers"
				          :items="filterTablaInbi"
				          class="elevation-0"
				          dense
				          mobile-breakpoint="200"
					      	v-model="selectedInbi"
				          item-key="folio"
    							show-select
				        >

				        	<template v-slot:item.folio="{ item }">
				        		<v-icon color="red" v-if="item.finalizo">mdi-circle-medium</v-icon>
				        		{{ item.folio }}
				        	</template>

				        	<template v-slot:item.mensajes_repetidos="{ item }">
				        		<v-chip color="primary" small @click="mensajesRepetidos = item.mensajes_repetidos_all, dialogMensajesRepetidos = true">{{ item.mensajes_repetidos }} </v-chip>
				        	</template>

				        	<template v-slot:item.mensajes_pdf="{ item }">
				        		<v-chip dark :color="item.mensajes_pdf >= 1 && item.mensajes_antes_pdf <= 3 ? 'red' : '' " small >{{ item.mensajes_pdf }}</v-chip>
				        	</template>

				        	<template v-slot:item.estatus_seguimiento="{ item }">
				        		<v-chip color="green"   dark small v-if="item.estatus_seguimiento == 1">Bueno</v-chip>
				        		<v-chip color="orange"  dark small v-if="item.estatus_seguimiento == 2">Regular</v-chip>
				        		<v-chip color="black"   dark small v-if="item.estatus_seguimiento == 3">Malo</v-chip>
				        		<v-chip color="red"     dark small v-if="item.estatus_seguimiento == 4">Sin seguimiento</v-chip>
	        					<v-chip color="blue"    dark small v-if="item.estatus_seguimiento == 5">Cliente nunca respondió</v-chip>
	        					<v-chip color="pink"    dark small v-if="item.estatus_seguimiento == 6">Cliente dejó de responder</v-chip>
	        					<v-chip color="yellow"       small v-if="item.estatus_seguimiento == 7">Cliente en espera</v-chip>
				        	</template>

				        	<template v-slot:item.etiqueta="{ item }">
				        		<v-chip :color="item.color"  v-if="item.etiqueta" dark small >{{ item.etiqueta }}</v-chip>
				        	</template>

				        	<template v-slot:item.error="{ item }">
						  			<v-chip
				              v-if="item.msnDuplicado"
				              color="red"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Msn duplicado
				            </v-chip><br v-if="item.msnDuplicado"/>
				            <v-chip
				              v-if="item.pdfInicio"
				              color="blue"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Pdf en los 1eros Msn
				            </v-chip><br v-if="item.pdfInicio"/>
				            <v-chip
				              v-if="item.clienteEspera"
				              color="orange"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Cliente espera
				            </v-chip><br v-if="item.clienteEspera"/>
				            <v-chip
				              v-if="item.sinError"
				              color="green"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Sin error
				            </v-chip><br v-if="item.sinError"/>
				            
				            <v-chip
				              v-if="item.noIniciado && item.colorRed" 
				              color="red"
				              dark
				              hide-details
				              class="mb-1"
				              small
				            >
				              No se ha mandado 1er mensaje
				            </v-chip>

				            <v-chip
				              v-if="item.noIniciado && !item.colorRed" 
				              color="yellow"
				              hide-details
				              class="mb-1"
				              small
				            >
				              No se ha mandado 1er mensaje
				            </v-chip>

				        	</template>

				        </v-data-table>
		    			</v-card-text>
		    		</v-card>					
		    	</v-col>

		    	<v-divider></v-divider>

		    	<v-col cols="12">
		    		<!-- <div ref="chartdivfast" style="width: 100%; height: 600px;" v-show="verGraficaFast"></div> -->
		    		<v-card class="elevation-0">
		    			<v-card-title primary-title class="text-body-1">
		    			  Reporte Fast
		    			  <v-spacer></v-spacer>
		    			  <v-btn 
				          class="mr-2" 
				          small dark color="green"
				          @click="exportExcel( tablaFast  , 'REPORTE_FAST')"
				          tile
				        >
				          <v-icon small>mdi-microsoft-excel</v-icon>
				        </v-btn>
		    				<v-btn dark @click="dialogAlerta = true" small color="primary" v-if="selectedInbi.length > 0">REASIGNARRR</v-btn>
		    			</v-card-title>
		    			<v-card-text>
			    		  <v-data-table
				          :headers="headers"
				          :items="filterTablaFast"
				          class="elevation-0"
				          v-model="selectedInbi"
				          item-key="folio"
				          dense
				          mobile-breakpoint="200"
    							show-select
				        >

				        	<template v-slot:item.folio="{ item }">
				        		<v-icon color="red" v-if="item.finalizo">mdi-circle-medium</v-icon>
				        		{{ item.folio }}
				        	</template>

									<template v-slot:item.mensajes_repetidos="{ item }">
				        		<v-chip color="primary" small @click="mensajesRepetidos = item.mensajes_repetidos_all, dialogMensajesRepetidos = true">{{ item.mensajes_repetidos }} </v-chip>
				        	</template>

				        	<template v-slot:item.estatus_seguimiento="{ item }">
				        		<v-chip color="green"   dark small v-if="item.estatus_seguimiento == 1">Bueno</v-chip>
				        		<v-chip color="orange"  dark small v-if="item.estatus_seguimiento == 2">Regular</v-chip>
				        		<v-chip color="black"   dark small v-if="item.estatus_seguimiento == 3">Malo</v-chip>
				        		<v-chip color="red"     dark small v-if="item.estatus_seguimiento == 4">Sin seguimiento</v-chip>
	        					<v-chip color="blue"    dark small v-if="item.estatus_seguimiento == 5">Cliente nunca respondió</v-chip>
	        					<v-chip color="pink"    dark small v-if="item.estatus_seguimiento == 6">Cliente dejó de responder</v-chip>
	        					<v-chip color="yellow"       small v-if="item.estatus_seguimiento == 7">Cliente en espera</v-chip>
				        	</template>

				        	<template v-slot:item.etiqueta="{ item }">
				        		<v-chip :color="item.color"  v-if="item.etiqueta" dark small >{{ item.etiqueta }}</v-chip>
				        	</template>

				        	<template v-slot:item.error="{ item }">
						  			<v-chip
				              v-if="item.msnDuplicado"
				              color="red"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Msn duplicado
				            </v-chip><br v-if="item.msnDuplicado"/>
				            <v-chip
				              v-if="item.pdfInicio"
				              color="blue"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Pdf en los 1eros Msn
				            </v-chip><br v-if="item.pdfInicio"/>
				            <v-chip
				              v-if="item.clienteEspera"
				              color="orange"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Cliente espera
				            </v-chip><br v-if="item.clienteEspera"/>
				            <v-chip
				              v-if="item.sinError"
				              color="green"
				              hide-details
				              class="mb-1"
				              small
				              dark
				            >
				              Sin error
				            </v-chip><br v-if="item.sinError"/>

				            <v-chip
				              v-if="item.noIniciado && item.colorRed" 
				              color="red"
				              dark
				              hide-details
				              class="mb-1"
				              small
				            >
				              No se ha mandado 1er mensaje
				            </v-chip>

				            <v-chip
				              v-if="item.noIniciado && !item.colorRed" 
				              color="yellow"
				              hide-details
				              class="mb-1"
				              small
				            >
				              No se ha mandado 1er mensaje
				            </v-chip>

				        	</template>
				        	
				        </v-data-table>
		    			</v-card-text>
		    		</v-card>					
		    	</v-col>

		    </v-row>
		  </v-card-text>
		  <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogBuenSeguimiento.estatus = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		</v-card>

		<v-dialog
		  v-model="dialogMensajes"
		  max-width="1400px"
		>
		  <v-card>
		    <v-card-title class="text-subtitle-1">
		      Datos de los contactos
		      <v-spacer></v-spacer>
		      <v-btn 
	          class="mr-10" 
	          small dark color="green"
	          @click="exportExcel( dataTableContactos  , 'MENSAJES')"
	          tile
	        >
	          <v-icon small>mdi-microsoft-excel</v-icon>
	        </v-btn>
		    </v-card-title>

		    <v-card-text>
		      <v-data-table
	          :headers="headers"
	          :items="dataTableContactos"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	        >
	        </v-data-table>
		    </v-card-text>
		    <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogMensajes = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		  </v-card>
		</v-dialog>

		<v-dialog
		  v-model="dialogMensajesRepetidos"
		  max-width="1400px"
		>
		  <v-card>
		    <v-card-title class="text-subtitle-1">
		      Datos de los contactos
		      <v-spacer></v-spacer>
		      <v-btn 
	          class="mr-10" 
	          small dark color="green"
	          @click="exportExcel( mensajesRepetidos  , 'MENSAJES')"
	          tile
	        >
	          <v-icon small>mdi-microsoft-excel</v-icon>
	        </v-btn>
		    </v-card-title>

		    <v-card-text>
		      <v-data-table
	          :headers="headersRepetidos"
	          :items="mensajesRepetidos"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	        >
	        </v-data-table>
		    </v-card-text>
		    <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogMensajesRepetidos = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		  </v-card>
		</v-dialog>

		<v-dialog
    	v-model="dialogAlerta"
    	max-width="400"
    >	
    	<v-card>
    		<v-card-title></v-card-title>
    		<v-card-text class="black--text text-center" >
			    <v-autocomplete
	          filled
	          dense
	          clearable
	          v-model="vendedoraUnica"
	          :items="vendedorasReasignar"
	          label="Selecciona vendedora"
	          hide-details
	          item-text="nombre_completo"
	          item-value="id_ciclo"
	          return-object
	        >
	        </v-autocomplete>
    		</v-card-text>
    		<v-card-actions>
    			<v-btn color="black" dark small @click="dialogAlerta = false">No, cancelar</v-btn>
    			<v-spacer></v-spacer>
    			<v-btn color="green" dark small @click="iniciarReasignacion( )" v-if="opReasigancion">Sí, seguro</v-btn>
    		</v-card-actions>
    	</v-card>
    </v-dialog>

		<VendedoraSeguimiento
      v-if="dialogReporteVendedora.estatus"
      :dialogReporteVendedora="dialogReporteVendedora"
      :contadorVendedoras="contadorVendedoras"
      :escuela="escuela"
      :tablaInbi="filterTablaInbi"
			:tablaFast="filterTablaFast"
			:vendedoras="vendedoras"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from "vuex";
	// Componentes
	import Alerta from "@/components/alertas/Alerta.vue";
	import carga from "@/components/alertas/carga.vue";

	import validarErrores from "@/mixins/validarErrores";
	import funcionesExcel from "@/mixins/funcionesExcel";

	import * as am5 from "@amcharts/amcharts5";
	import * as am5xy from "@amcharts/amcharts5/xy";
	import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

  import VendedoraSeguimiento       from '@/components/leads/VendedoraSeguimiento'


	export default {

	  mixins: [ validarErrores, funcionesExcel ],

	  props: ['dialogBuenSeguimiento','escuela', 'nivel','leccion', 'contadorVendedoras'],

	  components: {
	    Alerta,
	    carga,
	    VendedoraSeguimiento
	  },

		data: () => ({
	    // Alertas
	    parametros:{
	      dialogError: false,
	      mensaje: '',
	      color: ''
	    },

	    respuestaAlerta:false,
	    loader: true,
	    cargar: false,

	    fechaini: null,
	    fechafin: null,

	    planteles:[],

	    verGraficaInbi: false,
	    verGraficaFast: false,
	    chart: null,
      root: null,
      loading: true,

      tablaInbi: [],
      tablaFast:[],
      dataTableContactos:[],
			dialogMensajes: false,

			sinSpam: 0,

			ventanaCerrada: 0,

			headers:[
				{ text: "Folio"              , value: "folio"               },
        { text: "Twilio"             , value: "twilio"              },
        { text: "Twilio BD"          , value: "twilio_db"           },
        { text: "Etiqueta"           , value: "etiqueta"            },
        { text: "Nombre"             , value: "nombre_completo"     },
        { text: "Vendedora"          , value: "vendedora"           },
        { text: "Tiempo espera Real" , value: "tiempo_promedio"     },
        { text: "Tiempo espera Reloj", value: "tiempo_reloj"        },
        { text: "Mensajes Repetidos" , value: "mensajes_repetidos"  },
        { text: "Msn Cliente"        , value: "mensajes_clientes"   },
        { text: "Msn Totales"        , value: "mensajes_totales"    },
        { text: "Msn Vendedora"      , value: "mensajes_mios"       },
        { text: "#Msn Texto"         , value: "mensajes_texto"      },
        { text: "# PDF"              , value: "mensajes_pdf"        },
        { text: "# Audios"           , value: "mensajes_audios"     },
        // { text: "Estatus"            , value: "estatus_seguimiento" },
        { text: "ERROR"              , value: "error" },
			],

			headersRepetidos:[
        { text: "Twilio"             , value: "usuario"             },
        { text: "Mensaje"            , value: "mensaje"             },
			],

			vendedora: null,
			vendedoras:[],

			dialogMensajesRepetidos: false,
			mensajesRepetidos: [],

			dialogReporteVendedora:{
				estatus: false
			},

			selectedInbi:[],
			selectedFast:[],

			dialogAlerta: false,

			vendedoraUnica: null,
			vendedorasReasignar:[],

			opEstatus: null,
			estatus_list:[
				{id: 1, estatus: 'Bueno'},
				{id: 2, estatus: 'Regular'},
				{id: 3, estatus: 'Malo'},
				{id: 4, estatus: 'Sin seguimiento'},
				{id: 5, estatus: 'Cliente nunca respondió'},
				{id: 6, estatus: 'Cliente dejó de responder'},
				{id: 7, estatus: 'Cliente en espera'},
			],

			opReasigancion: 2,

			msnDuplicado: 0,
			pdfInicio:0,
			clienteEspera: 0,
			sinError: 0,
			noIniciado: 0,

			opTwilio: 3,

			sinCRM: 0,
			sinFinalizar:0,
	  }),

	  computed: {
	  	...mapGetters('login',['getdatosUsuarioERPERP']),
	    formTitle () {
	      return this.editedIndex === -1 ? 'Agregar Diapositiva' : 'Editar Diapositiva'
	    },

	    filterTablaInbi( ){

	    	let data = this.tablaInbi

	    	if( this.opTwilio == 1 ){ data = data.filter( el => el.nombre_completo.match('TWILIO') )}

	    	if( this.opTwilio == 2 ){ data = data.filter( el => !el.nombre_completo.match('TWILIO') )}

	    	if( this.vendedora ){

	    		data = data.filter( el => el.usuario_asignado == this.vendedora )

	    	}

	    	if( this.opEstatus ){

	    		data = data.filter( el => el.estatus_seguimiento == this.opEstatus )

	    	}

	    	if( this.msnDuplicado ){ data = data.filter( el => el.msnDuplicado == this.msnDuplicado ) }
				if( this.pdfInicio ){ data = data.filter( el => el.pdfInicio == this.pdfInicio ) }
				if( this.clienteEspera ){ data = data.filter( el => el.clienteEspera == this.clienteEspera ) }
				if( this.sinError ){ data = data.filter( el => el.sinError == this.sinError ) }
				if( this.noIniciado ){ data = data.filter( el => el.noIniciado == this.noIniciado ) }

				if( this.sinSpam ){ data = data.filter( el => el.idetiquetas != 7 )}
				if( this.ventanaCerrada ){ data = data.filter( el => !el.ventanaCerrada ) }
				if( this.sinCRM ){ data = data.filter( el => el.twilio_db != 'TWILIO CRM INBI')}
				if( this.sinFinalizar ){ data = data.filter( el => !el.finalizo ) }

	    	return data

	    },

			filterTablaFast( ){

				let data = this.tablaFast

				if( this.opTwilio == 1 ){ data = data.filter( el => el.nombre_completo.match('TWILIO') )}

				if( this.opTwilio == 2 ){ data = data.filter( el => !el.nombre_completo.match('TWILIO') )}

				if( this.vendedora ){

					data = data.filter( el => el.usuario_asignado == this.vendedora )

				}

				if( this.opEstatus ){

					data = data.filter( el => el.estatus_seguimiento == this.opEstatus )

				}

				if( this.msnDuplicado ){ data = data.filter( el => el.msnDuplicado == this.msnDuplicado ) }
				if( this.pdfInicio ){ data = data.filter( el => el.pdfInicio == this.pdfInicio ) }
				if( this.clienteEspera ){ data = data.filter( el => el.clienteEspera == this.clienteEspera ) }
				if( this.sinError ){ data = data.filter( el => el.sinError == this.sinError ) }
				if( this.noIniciado ){ data = data.filter( el => el.noIniciado == this.noIniciado ) }

				if( this.sinSpam ){ data = data.filter( el => el.idetiquetas != 7 )}
				if( this.ventanaCerrada ){ data = data.filter( el => !el.ventanaCerrada ) }
				if( this.sinCRM ){ data = data.filter( el => el.twilio_db != 'TWILIO CRM INBI')}
				if( this.sinFinalizar ){ data = data.filter( el => !el.finalizo ) }

				return data

			}

	  },

	  watch: {
	    dialogDelete (val) {
	      val || this.closeDelete( )
	    },

	    fechaini ( val ){
	      val || this.initialize( )
	    }
	  },

	  async created () {
	    // await this.initialize()
	    await this.getVendedorasCRM( )
	  },

	  mounted() {
	    
	  },

	  beforeDestroy() {
	    if (this.root) {
	      this.root.dispose();
	    }
  	},

	  methods: {

	    initialize() {
	      this.cargar = true;
	      this.vendedoras = []

	      const payload = {
	        fechaini : this.fechaini,
	        fechafin : this.fechafin
	      }

	      return axios.post('reporte.buen.seguimiento', payload ).then(response => {

	      	this.tablaInbi  = response.data.prospectosTwilioInbi 
	      	this.tablaFast  = response.data.prospectosTwilioFast 
	      	this.vendedoras = response.data.vendedorasAll 


	        // DATOS PARA LA GRAFICA
	        this.cargar = false;

	      }).catch(error => {
	        this.validarError(error.response.data.message);
	      }).finally(() => {
	        this.cargar = false;
	      });
	    },

	    getVendedorasCRM () {
      	this.cargar = true
        this.vendedorasReasignar = []
        return this.$http.get('vendedoras.list.crm').then(response=>{
        	this.vendedorasReasignar = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

	    close () {
	      this.dialog = false
	      this.$nextTick(() => {
	        this.editedItem = Object.assign({}, this.defaultItem)
	        this.editedIndex = -1
	      })
	    },

	    closeDelete () {
	      this.dialogDelete = false
	      this.$nextTick(() => {
	        this.editedItem = Object.assign({}, this.defaultItem)
	        this.editedIndex = -1
	      })
	    },

	    verMensajes( item ){
	      this.mensaje = null
	      this.mensaje = item.utlimomensaje
	      this.dialogVerMensaje = true
	    },

	    abrirDatos( datos ){
	    	this.dataTableContactos = datos
	    	this.dialogMensajes = true
	    },

	    getProspectosDetalle ( id_usuario ) {
      	this.cargar     = true // iniciar el load
        this.prospectos = []   // Limpiamos prospectos

        return this.$http.get('prospectos.detalle/' + id_usuario ).then(response=>{
        	
        	this.prospectos = response.data // capturamos la respuesta
        	this.cargar      = false        // Cerramos el loader
        
        }).catch( error =>{
        	// Lanzamos el error 
          this.validarError( error.response.data.message )
        
        }).finally( () => { this.cargar = false })
      },

	    iniciarReasignacion(){

      	// Mandamos los datos completos
      	const payload = {
      		vendedora            : this.vendedora,
					prospectosAReasignar : this.selectedInbi,
					opReasigancion       : this.opReasigancion,
					vendedoraUnica       : this.vendedoraUnica
      	}

      	this.cargar = true
        
        return this.$http.post('reasignar.prospectos.masivo', payload ).then(response=>{

        	// Validamos que haya una vendedora seleccionada
        	if( this.vendedora ){

	      		// Desestrcuturamos el valor y sacamos el usuario
	      		const { id_usuario } = this.vendedora

	      		// console.log( this.vendedora )

	      		// return 

	      		// mandamos a llamar a la consulta
	      		this.getProspectosDetalle( this.vendedora )

	      	}

	      	this.selectedInbi         = []
	      	this.vendedoraUnica       = null

        	this.validarSuccess('Datos reasignados correctamente')
        	this.dialogAlerta = false
        	this.cargar       = false
        	this.getVendedorasCRM( )
	      	// Agregarmos primero los datos
	      	
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      }

	  },
	}
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }

  .chat {
    width: calc(100%);
  }

  .chat .messages-chat {
    padding: 25px 10px;
  }

  .chat .messages-chat .message {
    display:flex;
    align-items: center;
    margin-bottom: 2px;
  }

  .chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .chat .messages-chat .text {
    margin: 0 35px;
    background-color: #fff;
    padding: 15px;
    border-radius: 12px;
  }

  .text-only {
    white-space: pre-line;

  }

  .time {
    font-size: 12px;
    color:lightgrey;
    margin-bottom:10px;
    margin-left: 38px;
  }

  .response-time {
    float: right;
    margin-right: 40px !important;
  }

  .response {
    float: right;
    margin-right: 0px !important;
    margin-left: auto; /* flexbox alignment rule */
    max-width: 90%;
  }

  .noresponse {
    max-width: 90%;
  }

  .noresponse .text{
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .response .text {
    background-color: #c5e6c1 !important;
    color: black;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;

  }

  .audio {
    background-color: #f1f3f4 !important;
  }

  .response .audio {
    background-color: #f1f3f4 !important;
  }

  .footer-chat {
    width: calc(65% - 66px);
    height: 80px;
    display:flex;
    align-items: center;
    position:absolute;
    bottom: 0;
    background-color: transparent;
    border-top: 2px solid #EEE;

  }

  .chat .footer-chat .icon {
    margin-left: 30px;
    color:#C0C0C0;
    font-size: 14pt;
  }

  .chat .footer-chat .send {
    color:#fff;
    background-color: #4f6ebd;
    position: absolute;
    right: 50px;
    padding: 12px 12px 12px 12px;
    border-radius: 50px;
    font-size: 14pt;
  }

  .chat .footer-chat .name {
    margin: 0 0 0 20px;
    text-transform: uppercase;
    font-family:'Montserrat', sans-serif;
    font-size: 13pt;
    color:#515151;
  }

  .chat .footer-chat .right {
    position: absolute;
    right: 40px;
  }
</style>